import React from "react";
import Modal from "react-modal";
import { useNavigate } from "react-router-dom";

Modal.setAppElement("#root");

// Shown when the server refuses a project: it was deleted, the id is wrong,
// or it belongs to another account. There is nothing to edit, so the only
// way out is back to the dashboard.
export default function ProjectUnavailableModal({ isOpen }) {
  const navigate = useNavigate();
  const goToDashboard = () => navigate("/dashboard", { replace: true });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={goToDashboard}
      shouldCloseOnOverlayClick={false}
      contentLabel="Project not accessible"
      style={{
        overlay: {
          backgroundColor: "rgba(6, 5, 12, 0.72)",
          backdropFilter: "blur(8px)",
          zIndex: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        },
        content: {
          position: "relative",
          inset: "auto",
          width: "min(420px, calc(100vw - 32px))",
          maxHeight: "calc(100vh - 32px)",
          margin: "auto",
          padding: 0,
          border: "1px solid rgba(124, 92, 255, 0.25)",
          borderRadius: "20px",
          background: "#12101c",
          overflow: "hidden",
          outline: "none",
        },
      }}
    >
      <div className="p-7 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[rgba(124,92,255,0.15)] border border-[rgba(124,92,255,0.35)]">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#c4b2ff"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <rect x="4" y="11" width="16" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
          </svg>
        </div>

        <h2 className="font-body text-[22px] font-semibold text-white tracking-tight leading-snug">
          Project not accessible
        </h2>
        <p className="mt-2 font-body text-[14px] leading-relaxed text-[#a19dbb]">
          This project may have been deleted, or it belongs to another
          account.
        </p>

        <button
          type="button"
          onClick={goToDashboard}
          className="mt-7 w-full py-3 rounded-xl bg-[#7c5cff] text-white font-body text-[15px] font-semibold hover:bg-[#9d7dff] transition-all hover:-translate-y-px hover:shadow-[0_8px_24px_-8px_rgba(124,92,255,0.6)]"
        >
          Back to dashboard
        </button>
      </div>
    </Modal>
  );
}
